import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import Card, { SectionTitle } from "@/components/base/Card";
import { formatMoney } from "@/utils/format";
import type { CycleBalance } from "@/services/financeService";

interface Props {
  balances: CycleBalance[];
  cycleLabels: Record<string, string>;
}

export default function FinanceOverview({ balances, cycleLabels }: Props) {
  const data = balances.map((b) => ({
    name: cycleLabels[b.cycleId] ?? b.cycleId,
    Recettes: b.recettes,
    Dépenses: b.depenses,
  }));

  return (
    <Card>
      <SectionTitle
        icon="ri-exchange-dollar-line"
        title="Recettes vs dépenses par cycle"
        subtitle="Vue comparée du cycle en cours"
      />
      <div className="h-[240px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }} barGap={8}>
            <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-300))" vertical={false} />
            <XAxis dataKey="name" tick={{ fontSize: 12, fill: "oklch(var(--foreground-500))" }} axisLine={false} tickLine={false} />
            <YAxis
              tick={{ fontSize: 11, fill: "oklch(var(--foreground-400))" }}
              axisLine={false}
              tickLine={false}
              tickFormatter={(v: number) => `${(v / 1_000_000).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} M`}
            />
            <Tooltip
              formatter={(value: number) => formatMoney(value)}
              contentStyle={{
                borderRadius: 8,
                border: "1px solid oklch(var(--background-200))",
                background: "oklch(var(--background-50))",
                fontSize: 12,
              }}
            />
            <Bar dataKey="Recettes" fill="oklch(var(--primary-500))" radius={[4, 4, 0, 0]} maxBarSize={48} />
            <Bar dataKey="Dépenses" fill="oklch(var(--accent-500))" radius={[4, 4, 0, 0]} maxBarSize={48} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}